module.exports = function toLocalISOString(d) {
    const off = d.getTimezoneOffset();
    const date = new Date(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes() - off, d.getSeconds(), d.getMilliseconds());
    return date.toISOString().split('T')[0];
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/utility/data-toLocalIsoString.js
 **/